module.exports = __webpack_public_path__ + "img/close-pink.fe99294d.svg";